import PropTypes from "prop-types";

const Header = ({ children }) => {
 return <div className="px-[70px] mt-10">{children}</div>;
};

Header.propTypes = {
 children: PropTypes.node.isRequired,
};

export default Header;
